module.exports = __webpack_public_path__ + "img/credit-builder-icon.a394a321.svg";